import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import { API, put } from 'utils/api';

import type { BrandProfile, Dispatch, InfluencerProfile, ThunkAction } from 'types';

export function changeApprovalStatus(
  {
    id
  }: InfluencerProfile | BrandProfile,
  profileType: string,
  status: string,
  externalReason: string,
  internalReason?: string | null
): ThunkAction {
  const url = API.END_POINTS.ADMIN.getProfileApprovalUrl(profileType, id);

  const data = {
    status,
    externalReason,
    internalReason
  };

  return (dispatch: Dispatch) => {
    dispatch(showLoading(url));

    return put(url, { data })
      .then(() => dispatch(hideLoading(url)))
      .catch(() => dispatch(hideLoading(url)));
  };
}
